;; ##CANONICAL##
(ns kc.spa 
  (:require
    [kc.core :as kc]
    [clojure.string :as str]))


;;; desktop constants

(def element-id--desktop "Desktop")

;;; location

(defn -location->url [location]
  (let [base (str "#" (:page location))]
    (if-let [params (:params location)]

      (str base "?"
           (->> params
                (sort-by first)
                (remove #(nil? (second %)))
                (map (fn [[k v]]
                       (kc/assert (simple-keyword? k))
                       (str (name k)"="
                            (js/encodeURIComponent v))
                       ))
                (str/join "&")))
      
      base)))

(defn goto-location!
  "Navigate to `location`.

  `(goto {:page \"some-page\" :params {:x 1 :y 2}})`
  "
  [location]
  (kc/log location)

  (let [location (cond
                   (string? location) {:page location}
                   (keyword? location) {:page (name location)}
                   :else location)]

    (js/window.history.pushState
     (clj->js location)
     ""
     (-location->url location))
    (when-let [desktop-elem (js/document.getElementById element-id--desktop)]
      (-> desktop-elem
          (.scrollTo #js {:top 0 :left 0
                          :behavior "smooth"})))

    (kc/update-context! :spa/location location)))


(defn use-location-page []
  (kc/use-from-context [:spa/location :page]))

(defn use-location-params []
  (kc/use-from-context [:spa/location :params]))


(defn location-materialize! []
  (kc/log js/window.location.href)
  (let [[page query] (str/split js/window.location.hash #"\?")
        page (subs page 1)
        ;; _ (utils/LOG! {:page page
        ;;                :query query})
        query (kc/str-trimmed-non-blank query)
        url-search-params (when query
                            (-> query
                                js/URLSearchParams.))
        params (when url-search-params
                 (reduce (fn [m k]
                           (assoc m (keyword k)
                                  (-> url-search-params
                                      (.get k))))
                         {} (.keys url-search-params)))
        location {:page page
                  :params params}
        old-location (kc/from-context :spa/location)]
    (when (not= location old-location)
      (kc/log ":spa/location changed"
              {:from old-location
               :to location})
      (kc/update-context! :spa/location location))))

(defn on-popstate [^js ev]
  (kc/log ev)
  (location-materialize!))

(defn init-router []
  (js/window.addEventListener "popstate" on-popstate))
